"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../../");

var _propTypes = _interopRequireDefault(require("prop-types"));

var Banner = function Banner(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cloud-ui-banner', "banner-".concat(props.type))
  }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
    name: "error-solid"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "banner-text"
  }, props.children), props.onClose && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: props.onClose,
    className: "banner-close"
  }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
    name: "close"
  })));
};

var _default = Banner;
exports["default"] = _default;
Banner.propTypes = {
  type: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].element.isRequired,
  onClose: _propTypes["default"].func
};